import { PageLoading } from "@ant-design/pro-layout";
import routes from "constants/routes";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Jumping: React.FC = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const history = useHistory();
  const currentSiteId = useSelector((state: any) => state.site.currentSiteId);
  React.useLayoutEffect(() => {
    const targetId = query.get("id") || currentSiteId;
    dispatch({
      type: "Site/setCurrentSiteId",
      payload: targetId,
    });
    setTimeout(() => {
      const redirectTo = query.get('to') ?? routes.OVERVIEW
      history.replace(redirectTo);
    }, 1000);
  }, [currentSiteId, dispatch, history, query]);
  return <PageLoading tip="正在前往站点" />;
};

export default Jumping;
